<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to2 Your Vue.js App"/> -->
  <div class="outerShell">
    <CoalHeader class="header pageitem"></CoalHeader>
    <CoalQuery></CoalQuery>
    <CoalBody class="cbody pageitem"></CoalBody>
    <CoalFooter class="footer pageitem"></CoalFooter>
    <CoalToaster></CoalToaster>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import CoalHeader from './components/CoalHeader.vue'
import CoalBody from './components/CoalBody.vue'
import CoalFooter from './components/CoalFooter.vue'
import CoalQuery from './components/CoalQuery.vue'
import CoalToaster from './components/CoalToaster.vue'

export default {
  name: 'App',
  components: {
    CoalHeader,
    CoalBody,
    CoalFooter,
    CoalQuery,
    CoalToaster
  }
}

</script>

<style scoped>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  /* background-color: black; */
  /* margin-top: 60px; */
}


.header {
  position: sticky;
  top: 0;
  background-color: black;
  min-height: 80px;
  border-color: white;
  border-style: solid;
  border-width: 4px;
  z-index: 100;

  margin-left: 15%;
  margin-right: 15%;
  margin-bottom: 1%;
  padding: 2%;
  margin-top: 1%;
  min-width: 420px;
}

.pageitem {
  margin-right: 10%;
  margin-left: 10%;
  background-color: black;

}
</style>

<style>
.rot180 {
  transform: rotate(180deg);
}

* {
  color: white;
  font: 13px/1.5 arial, helvetica, sans-serif;
  font-weight: bold;

}

.tit {
  font: 32px/1.5 arial, helvetica, sans-serif;

}

.mbody {
  margin-left: 15%;
  margin-right: 15%;
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 3%;
  padding-bottom: 3%;
  margin-bottom: 1%;
  margin-top: 1%;
  min-width: 350px;
}

button {
  color: white;
  background-color: black;
  border-color: white;
  margin: 0;
}

button .big {
  width: 100%;
}

p {
  text-indent: 15px;
}


/* .nobord {
  border: none;
}

td,
th {
  padding: 10px;
  text-align: center;
}

table tr:hover .redsele {
  background-color: rgb(75, 16, 16);
  cursor: pointer;
} */
.mynftsbody {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

.mylinku {
  text-decoration: underline;
  cursor: pointer;
}

.mytableitem {
  width: 100%;
}

.mynftsitem {
  /* display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column; */
  /* flex-basis: 100%; */
  margin-right: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  /* margin-left: 1%; */
  border-color: white;
  border-style: solid;
  border-width: 2px;
  border-radius: 0%;
  padding: 2%;
  align-items: stretch;
  margin-top: 2%;
  min-width: 300px;
  max-width: 300px;
}

/* td ~.wbord{
  text-align: center;
} */

/* td:nth-child(1) ~.wbord{
  text-align: left;
} */

.wbord {
  border: 1px solid white;
  border-collapse: collapse;
  text-align: center;
}


/* table:hover tr:hover ~tr {
  background:none;
} */

.genholder {
  display: flex;
  justify-content: center;
}

.genholderv {
  flex-direction: column;

}

.genholderh {
  flex-direction: row;
}

table {
  margin-top: 5%;
}

.centex {
  margin-right: 5%;
  margin-left: 5%;
  width: 100%;
  text-align: center;
}

td button {
  width: 100%;
}

.mytex {
  background-color: black;
  text-align: center;
}

.mytexredbord {
  border-color: red;

}

.smalltex {
  font: 10px/1.5 arial, helvetica, sans-serif;
  text-align: center;
}

.myhover:hover {
  text-decoration: underline;
  cursor: pointer;
}

.mineitembord {
  padding-bottom: 2%;
  border-width: 4px;
  border-style: solid;
  margin-top: 3%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 10px;
}

.mseleitem {
  /* background-color: rgb(32, 32, 32); */
  /* box-shadow: 5px 5px rgb(0, 142, 207); */
  /* transition: 0.4s; */

  animation: seleanim .15s infinite alternate;
  animation-iteration-count: 7;
}

.mseleitem:hover {
  /* background-color: rgb(32, 32, 32); */
  box-shadow: none;
  /* animation-play-state: paused; */
}


@keyframes seleanim {
  0% {
    border-color: rgb(150, 8, 8);
    /* box-shadow: 5px 5px rgb(0, 217, 255); */

  }

  100% {
    border-color: white;

    /* box-shadow: 0px 0px rgb(255, 255, 255); */

  }

}

.setpris {
  border-width: 4px;
  border-color: white;
  /* overflow: hidden; */
  border-style: solid;
  background-color: black;
  padding: 5%;
  padding-top: 1%;
  margin: 15%;
  margin-left: 30%;
  margin-right: 30%;
}

.setprisouter {
  position: fixed;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 100%;
  background-color: rgba(53, 53, 53, 0.5);
  /* padding: 25%; */
  z-index: 200;
}

button:hover {
  transition: 1s;
  color: red;
}

.nousersel {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>